import { useMemo } from 'react';
import type { ODataGridColumn } from '@inuxe/prime-odata-grid';
import type { IExpenseResult } from '../../../models/expense/ExpenseModel';
import ExpenseManagementActionCell from './parts/ExpenseManagementActionCell';
import ExpenseStatusCell from './parts/ExpenseStatusCell';
import ExpenseAmountCell from './parts/ExpenseAmountCell';

export function useExpenseManagementColumns(
  showAdminColumns: boolean
): ODataGridColumn<IExpenseResult>[] {
  return useMemo<ODataGridColumn<IExpenseResult>[]>(
    () => [
      {
        id: 'actions',
        header: 'İşlemler',
        sortable: false,
        filter: false,
        width: 160,
        className: 'grid-action-column',
        actionSticky: 'left',
        body: row => <ExpenseManagementActionCell row={row} />,
      },
      {
        field: 'id',
        header: 'ID',
        dataType: 'numeric',
        width: 80,
        sortable: true,
        filter: true,
      },
      {
        field: 'userName',
        header: 'Kullanıcı',
        minWidth: 150,
        sortable: true,
        filter: true,
        hidden: !showAdminColumns,
      },
      {
        field: 'amount',
        header: 'Miktar',
        dataType: 'numeric',
        width: 150,
        sortable: true,
        filter: true,
        body: row => <ExpenseAmountCell row={row} />,
      },
      {
        field: 'expenseDate',
        header: 'Harcama Tarihi',
        dataType: 'date',
        minWidth: 150,
        sortable: true,
        filter: true,
        body: row =>
          row.expenseDate ? new Date(row.expenseDate).toLocaleDateString('tr-TR') : '',
      },
      {
        field: 'description',
        header: 'Açıklama',
        minWidth: 200,
        sortable: true,
        filter: true,
      },
      {
        field: 'status',
        header: 'Durum',
        width: 120,
        sortable: true,
        filter: true,
        hidden: !showAdminColumns,
        body: row => <ExpenseStatusCell row={row} />,
      },
      {
        field: 'createdDate',
        header: 'Oluşturulma Tarihi',
        dataType: 'date',
        minWidth: 160,
        sortable: true,
        filter: true,
        body: row =>
          row.createdDate ? new Date(row.createdDate).toLocaleDateString('tr-TR') : '',
      },
    ],
    [showAdminColumns]
  );
}
